import classNames from 'classnames';
import { m } from 'motion/react';

import styles from './Shimmer.module.scss';

type Props = {
  duration?: number;
  message?: string;
  subMessage?: string;
  rounded?: boolean;
  isSmall?: boolean;
  isProcessMessage?: boolean;
  className?: string;
};

const Shimmer: React.FC<Props> = ({
  duration,
  message = '',
  subMessage,
  rounded = false,
  isProcessMessage = false,
  isSmall = false,
  className,
}) => {
  const containerClasses = classNames(
    styles.container,
    {
      [styles.rounded]: rounded,
      [styles.small]: isSmall,
    },
    className,
  );

  const messageClasses = classNames(styles.message, {
    [styles.processMessage]: isProcessMessage,
  });

  return (
    <div className={containerClasses}>
      <m.div
        className={styles.shimmer}
        initial={{ scale: 2 }}
        animate={{ x: ['-50%', '50%'] }}
        transition={{ duration: 0.5, repeat: Infinity, repeatType: 'mirror' }}
      />
      {message && (
        <>
          <m.span
            className={messageClasses}
            animate={{ opacity: [0.4, 0.8] }}
            transition={{ duration: duration || 0.5, repeat: Infinity, repeatType: 'mirror' }}
          >
            {message}
          </m.span>
          {subMessage && <p className={styles.subMessage}>{subMessage}</p>}
        </>
      )}
    </div>
  );
};

export default Shimmer;
